import {
  Cascader,
  Checkbox,
  DatePicker,
  DateRangePicker,
  Input,
  InputNumber,
  Radio,
  Select,
  SelectInput,
  Switch,
  Upload,
} from 'tdesign-react';

import { CustomPlayInfo } from '@/pages/story/info/custom-form';

import UploadAudio from './form-upload/audio';
import UploadFile from './form-upload/file';
import UploadPic from './form-upload/image';
import UploadVideo from './form-upload/video';

export const customRender: Record<string, any> = {
  customPlayInfo: CustomPlayInfo,
  pic: UploadPic,
  file: UploadFile,
  audio: UploadAudio,
  video: UploadVideo,
};

export const baseRender: Record<string, any> = {
  input: Input,
  inputNumber: InputNumber,
  select: Select,
  selectInput: SelectInput,
  radio: Radio.Group,
  radioSingle: Radio,
  checkbox: Checkbox.Group,
  checkboxSingle: Checkbox,
  switch: Switch,
  cascader: Cascader,
  datepicker: DatePicker,
  rangepicker: DateRangePicker,
  number: InputNumber,
  upload: Upload,
};
